import ReactDOM from 'react-dom/client';
import { Suspense } from 'react';
import { CircularProgress } from '@material-ui/core';
import { ReactKeycloakProvider } from '@react-keycloak/web';

import { handleKeycloakEvent } from 'src/utils/authkeycloak';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './i18n';
import reportWebVitals from './reportWebVitals';
import keycloak from './keycloak';
import { setUserSession } from './utils/common';

const root = ReactDOM.createRoot(document.getElementById('root'));
console.log = () => {};
console.error = () => {};
console.debug = () => {};

root.render(
  <Suspense
    fallback={
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </div>
    }
  >
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={{
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: `${globalThis.location.origin}/silent-check-sso.html`,
      }}
      onEvent={(event, error) => handleKeycloakEvent(event, error, keycloak, setUserSession)}
    >
      <App />
    </ReactKeycloakProvider>
  </Suspense>
);

serviceWorker.unregister();

reportWebVitals();
